(function () {
// Custom alpine directives go here
//
// For example, `x-uppercase`:
//
// Alpine.directive('uppercase', (el) => {
//   el.textContent = el.textContent.toUpperCase();
// });
Alpine.magic('fetchedSection', () => {
  return (url, selector) => {
    return async () => {
      return await fetchSectionHTML(url, selector);
    };
  };
});

// Both native deferred loading and the early module path share one start gate.
let started = false;
function startTheme() {
  if (started) return;
  started = true;
  Alpine.start();
}
document.addEventListener('shapes:theme:ready', startTheme, { once: true });
document.addEventListener('DOMContentLoaded', startTheme, { once: true });

})();
